<template>
  <page-status class="proposal-sign" :loading="loading">
    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="基本信息" />
      </van-cell>
      <van-cell title="车牌号" :value="detail.licenseNo || '新车未上牌'" />
      <van-cell title="车架号" :value="detail.frameNo" />
      <van-cell title="投保人" :value="detail.appliName" />
      <van-cell
        v-if="detail.addressDetail"
        title="房屋地址"
        :value="detail.addressDetail"
        value-class="address-detail"
      />
      <van-cell
        v-if="fcTotalPremium !== ''"
        title="尊享保障总保费"
        :value="`${fcTotalPremium}元`"
      />
      <van-cell
        title="驾乘总保费"
        v-if="onlyShowJcFrame === '1'"
        :value="`${jcTotalPremium}元`"
      />
      <van-cell
        title="总保费"
        v-if="onlyShowJcFrame !== '1' && detail.totalPremium"
        :value="`${detail.totalPremium}元`"
      />
    </van-cell-group>

    <!-- <van-cell-group style="margin-top: 12px">
      <van-cell>
        <cell-header slot="title" title="条款信息" />
      </van-cell>
      <van-cell
        v-for="(clause, index) in detail.clauseVos"
        :key="index"
        @click="onViewClause(index)"
        is-link
      >
        <span :class="{ clause: true, active: clause.clicked }" slot="title">
          {{ `${index + 1}、${clause.clauseName}` }}
        </span>
      </van-cell>
    </van-cell-group> -->

    <!-- <div class="agreement">
      <van-checkbox v-model="checked">
        保险人已明确说明条款内容，免除保险人责任条款的含义及其法律后果
      </van-checkbox>
    </div>  -->

    <van-cell-group v-if="!checkSignFlag">
      <van-cell>
        <cell-header slot="title" title="投保人签名" />
      </van-cell>
      <div class="sign-container">
        <div class="sign-content">
          <vue-signature-pad width="100%" height="240px" ref="signaturePad" />
        </div>
        <div class="sign-actions">
          <van-button class="button" type="default" @click="onClearSignature()">
            重新签名
          </van-button>
          <van-button class="button" type="info" @click="onConfirmSignature()">
            确认投保
          </van-button>
        </div>
      </div>
    </van-cell-group>

    <div v-else class="sign-container">
      <div class="sign-actions">
        <van-button class="button" type="info" @click="toNextPage()">
          下一步
        </van-button>
        <!-- <van-button class="button" type="info" @click="toNextPage()">
          去认证签名
        </van-button> -->
      </div>
    </div>

    <page-footer />

    <van-dialog v-model="showDialog" title="提示">
      <div class="dialog-content" v-if="unreadItem">
        {{ `请先点击打开阅读《${unreadItem.clauseName}》` }}
      </div>
    </van-dialog>
    <van-popup
      :close-on-click-overlay="false"
      v-model="showClause"
      position="bottom"
      :style="{ height: '80%' }"
    >
      <div
        class="viewer-content"
        style="overflow: hidden; height: 90%"
        v-if="clauseUrlfc"
      >
        <iframe
          :src="clauseUrlfc"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </div>
      <div class="viewer-content" v-if="clauseUrl">
        <pdf-viewer :url="clauseUrl" />
      </div>
      <div class="viewer-footer">
        <van-button
          class="button"
          type="info"
          @click="closeClause()"
          :disabled="isClick"
        >
          {{ isClick ? `请您仔细阅读以上信息${time}秒` : `关闭` }}
        </van-button>
      </div>
    </van-popup>
  </page-status>
</template>

<script>
import { Toast } from 'vant';
import VueSignaturePad from 'vue-signature-pad';
import PageStatus from '@/components/PageStatus';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import PdfViewer from '@/components/PdfViewer';
import * as services from '@/services';
import * as cache from '@/utils/cache';
import { bindRecord } from '@/core/recorder';

export default {
  name: 'ProposalSign',
  components: {
    VueSignaturePad,
    PageStatus,
    CellHeader,
    PageFooter,
    PdfViewer,
  },

  data() {
    return {
      detail: {
        appliName: '',
        insuredName: '',
        biProposalNo: '',
        ciProposalNo: '',
        licenseNo: '',
        frameNo: '',
        totalPremium: '',
        payStatus: '',
        clauseVos: [],
      },
      loading: true,
      checked: false,
      showDialog: false,
      showClause: false,
      clauseUrl: '',
      clauseUrlfc: '',
      checkSignFlag: true, //是否需要验证签名
      faceIdFlag: false, //是否需要人脸识别
      onlyShowJcFrame: false,
      jcTotalPremium: '',
      fcTotalPremium: '',
      time: 0,
      isClick: true,
    };
  },

  computed: {
    unreadItem() {
      return this.detail.clauseVos.find(item => !item.clicked);
    },
  },

  watch: {
    checked(newValue) {
      if (this.unreadItem && newValue) {
        this.showDialog = true;
        this.checked = false;
      }
    },
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },
  mounted() {},
  activated() {
    this.$refs.signaturePad && this.$refs.signaturePad.resizeCanvas();
  },

  methods: {
    fetchData() {
      const { businessNo, mobile } = this.$route.query;

      // 绑定用户
      if (businessNo && mobile) {
        bindRecord({ userId: businessNo + '_' + mobile });
      }

      const proposalAuth = cache.removeItem('ProposalAuth');
      if (this.checkSameProposal(proposalAuth, businessNo, mobile)) {
        this.getProposalSuccess(proposalAuth);
        return;
      }

      services
        .getMotorProposal(businessNo, mobile)
        .then(res => this.getProposalSuccess(res));

      // 共建读非车条款
      // services
      //   .queryNoCarReadList(businessNo, mobile)
      //   .then(result => this.getNoCarReadListSuccess(result));
    },
    // 共建 post方法
    //  自建 get方法 ux
    getProposalSuccess(res) {
      const { businessNo, mobile } = this.$route.query;
      if (res.data.policyInfo.payStatus === '1') {
        const query = { businessNo, mobile };
        this.$router.replace({ path: '/insure-result', query });
      } else {
        this.checkSignFlag = res.data.checkSignFlag;
        this.faceIdFlag = res.data.faceIdFlag;
        this.realAuthSmsFlag = res.data.realAuthSmsFlag;
        this.detail = { ...this.detail, ...res.data.policyInfo };
        this.onlyShowJcFrame = res.data.policyInfo.onlyShowJcFrame;
        this.jcTotalPremium = res.data.policyInfo.jcTotalPremium;
        this.fcTotalPremium = res.data.policyInfo?.fcTotalPremium || '';
        this.loading = false;
      }
    },
    // getNoCarReadListSuccess(result) {
    //   this.fcTotalPremium = Number(result.content.totalPremium).toFixed(2);
    //   this.detail.addressDetail = result.content.addressDetail;
    //   const driverReadContent =
    //     result.content?.driverReadContent?.map(i => {
    //       return {
    //         clauseName: i.name,
    //         clauseUrl: i.url,
    //       };
    //     }) || [];
    //   const familyReadContent =
    //     result.content?.familyReadContent?.map(i => {
    //       return {
    //         clauseName: i.name,
    //         clauseUrl: i.url,
    //       };
    //     }) || [];
    //   this.checkSignFlag = true;
    //   this.detail.clauseVos = [
    //     ...this.detail.clauseVos,
    //     ...driverReadContent,
    //     ...familyReadContent,
    //   ];
    // },

    checkSameProposal(proposalAuth, businessNo, mobile) {
      return (
        proposalAuth &&
        proposalAuth.businessNo === businessNo &&
        proposalAuth.mobile === mobile
      );
    },

    onViewClause(index) {
      this.clauseUrl = null;
      this.clauseUrlfc = null;
      const { mobile } = this.$route.query;
      const clause = this.detail.clauseVos[index];
      if (clause.clicked) {
        this.isClick = false;
      } else {
        this.$set(this.detail.clauseVos, index, { ...clause, clicked: true });
        this.isClick = true;
        this.time = 5;
        this.countdown();
      }
      if (clause.clauseUrl) {
        this.showClause = true;
        this.clauseUrlfc = clause.clauseUrl;
      } else {
        this.showClause = true;
        this.clauseUrl = services.getMotorProposalLink(clause, mobile);
      }
    },

    countdown() {
      const timer = setInterval(() => {
        if (this.time !== 1) {
          this.time -= 1;
        } else {
          this.isClick = false;
          clearInterval(timer);
        }
      }, 1000);
    },

    closeClause() {
      this.showClause = false;
    },

    onClearSignature() {
      this.$refs.signaturePad.clearSignature();
    },

    onConfirmSignature() {
      if (!this.checked) {
        Toast({ message: '请确认勾选已阅读并接受以上条款信息' });
        return;
      }

      const signaturePad = this.$refs.signaturePad;
      const { isEmpty, data } = signaturePad.saveSignature();

      if (isEmpty) {
        Toast({ message: '请签名' });
        return;
      }

      Toast.loading({
        message: '正在上传签名',
        forbidClick: true,
        duration: 0,
      });

      const { query } = this.$route;
      const { businessNo, mobile } = query;
      const file = this.dataURLtoFile(data);

      services
        .signMotorProposal(businessNo, mobile, data, file)
        .then(({ data }) => this.signProposalSuccess(data, businessNo));
    },

    signProposalSuccess(data, businessNo) {
      if (data && data.payType === 'Bill99Pay') {
        this.getMotorPayUrl(businessNo);
      } else {
        this.toNextPage(data.checkMessageFlag);
        Toast.clear();
      }
    },
    toNextPage(checkMessageFlag = false) {
      const { query } = this.$route;
      const params = {
        ...query,
        realAuthSmsFlag: this.realAuthSmsFlag,
      };
      this.$router.push({ path: '/proposal-term', query: params });
    },

    // toNextPage(checkMessageFlag = false) {
    //   if (!this.checked) {
    //     Toast({ message: '请确认勾选已阅读并接受以上条款信息' });
    //     return;
    //   }

    //   const { query } = this.$route;
    //   const params = {
    //     ...query,
    //     realAuthSmsFlag: this.realAuthSmsFlag,
    //   };
    //   if (this.faceIdFlag) {
    //     this.$router.push({ path: '/certify', query: params });
    //   } else if (this.checkSignFlag) {
    //     this.$router.push({ path: '/signature', query: params });
    //   } else if (checkMessageFlag) {
    //     this.$router.push({ path: '/proposal-auth', query: params });
    //   } else if (realAuthSmsFlag) {
    //     this.$router.push({ path: '/eproposal/sms', query: params });
    //   } else {
    //     this.$router.push({ path: '/insure-payment', query: params });
    //   }
    // },

    getMotorPayUrl(businessNo) {
      services.getMotorPayUrl(businessNo).then(res => {
        const url = res.data;
        if (url) {
          window.location.href = url;
        }
        Toast.clear();
      });
    },

    dataURLtoFile(dataURL) {
      const parts = dataURL.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; i++) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      const filename = `${Date.now()}.png`;
      const blob = new Blob([uInt8Array], { type: contentType });
      return new File([blob], filename, { type: contentType });
    },
  },
};
</script>

<style lang="less">
.proposal-sign {
  width: 100%;
  height: 100%;
  padding-top: 12px;
  box-sizing: border-box;
  .address-detail {
    flex: 2;
  }
  .clause.active {
    color: #108ee9;
  }

  .agreement {
    padding: 12px;
    font-size: 14px;
  }

  .sign-container {
    padding: 12px;
  }

  .sign-content {
    background-color: #fafafa;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
  }

  .sign-actions {
    margin-top: 12px;
    text-align: center;
    display: flex;

    .button {
      flex: 1;
      border-radius: 4px;

      & + .button {
        margin-left: 12px;
      }
    }
  }

  .dialog-content {
    padding: 12px 24px;
    font-size: 14px;
    color: #030303;
    text-align: center;
  }

  .viewer-content {
    height: 100%;
    overflow: auto;
    background-color: #f9f9f9;
  }
  .viewer-footer {
    position: fixed;
    bottom: 0;
    height: 60px;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 100%;
    }
  }
}
</style>
